import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import logo from './../assets/logo_rigo_v2.png'

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

const handleLogin = async (e) => {
  e.preventDefault();
  setError('');

try {
  await axios.get('/api/csrf/', { withCredentials: true });

  await axios.post(
    '/api/login/',
    { username, password },
    { withCredentials: true }
  );

  await onLogin();
  navigate('/');
} catch (err) {
  console.error('Error en login:', err);
  setError('Credenciales inválidas o error de sesión.');
}

};

  return (
    <div className="
        min-h-screen
        bg-[#071120]
        relative
        overflow-hidden
        flex
        items-center
        justify-center
        ">

    {/* Glow Effects */}
    <div className="absolute inset-0 overflow-hidden pointer-events-none">

      <div
        className="
          absolute
          top-[-220px]
          left-[-220px]
          w-[520px]
          h-[520px]
          bg-cyan-500/10
          rounded-full
          blur-3xl
          animate-pulse
        "
      />

      <div
        className="
          absolute
          bottom-[-240px]
          right-[-240px]
          w-[560px]
          h-[560px]
          bg-blue-600/10
          rounded-full
          blur-3xl
          animate-pulse
        "
      />

    </div>
    {/* Cyber Grid Pattern */}
    <div
      className="
        absolute
        inset-0
        opacity-[0.04]
        pointer-events-none
        bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)]
        bg-[size:40px_40px]
      "
    />

      {/* Floating Particles */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
        {/* Left side */}
        <div className="absolute top-[10%] left-[10%] w-1 h-1 bg-cyan-300 rounded-full opacity-50 animate-pulse" />
        <div className="absolute top-[18%] left-[24%] w-1.5 h-1.5 bg-cyan-400 rounded-full opacity-60 animate-ping" />
        <div className="absolute top-[34%] left-[14%] w-1 h-1 bg-blue-300 rounded-full opacity-45 animate-pulse" />
        <div className="absolute top-[52%] left-[28%] w-1.5 h-1.5 bg-cyan-300 rounded-full opacity-50 animate-pulse" />
        <div className="absolute top-[72%] left-[16%] w-1 h-1 bg-blue-400 rounded-full opacity-40 animate-ping" />
        <div className="absolute top-[86%] left-[32%] w-1 h-1 bg-cyan-200 rounded-full opacity-35 animate-pulse" />

        {/* Center */}
        <div className="absolute top-[22%] left-[48%] w-1 h-1 bg-cyan-200 rounded-full opacity-35 animate-pulse" />
        <div className="absolute top-[44%] left-[52%] w-1.5 h-1.5 bg-blue-300 rounded-full opacity-40 animate-ping" />
        <div className="absolute top-[66%] left-[46%] w-1 h-1 bg-cyan-400 rounded-full opacity-45 animate-pulse" />

        {/* Right side */}
        <div className="absolute top-[12%] left-[78%] w-1 h-1 bg-blue-300 rounded-full opacity-45 animate-pulse" />
        <div className="absolute top-[28%] left-[72%] w-1.5 h-1.5 bg-blue-400 rounded-full opacity-50 animate-ping" />
        <div className="absolute top-[38%] left-[88%] w-1 h-1 bg-cyan-300 rounded-full opacity-45 animate-pulse" />
        <div className="absolute top-[58%] left-[76%] w-1.5 h-1.5 bg-cyan-400 rounded-full opacity-45 animate-pulse" />
        <div className="absolute top-[74%] left-[90%] w-1 h-1 bg-blue-300 rounded-full opacity-40 animate-ping" />
        <div className="absolute top-[86%] left-[82%] w-1 h-1 bg-cyan-200 rounded-full opacity-35 animate-pulse" />
      </div>

      {/* Hex Network Background */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none opacity-30 z-0"
        viewBox="0 0 1200 700"
        preserveAspectRatio="xMidYMid slice"
      >
        {/* Hexagons */}
        <g fill="none" stroke="#38bdf8" strokeWidth="1" opacity="0.22">
          <polygon points="160,220 210,190 260,220 260,280 210,310 160,280" />
          <polygon points="260,220 310,190 360,220 360,280 310,310 260,280" />
          <polygon points="210,310 260,280 310,310 310,370 260,400 210,370" />

          <polygon points="820,180 870,150 920,180 920,240 870,270 820,240" />
          <polygon points="920,180 970,150 1020,180 1020,240 970,270 920,240" />
          <polygon points="870,270 920,240 970,270 970,330 920,360 870,330" />

          <polygon points="720,470 770,440 820,470 820,530 770,560 720,530" />
          <polygon points="820,470 870,440 920,470 920,530 870,560 820,530" />
        </g>

        {/* Connections */}
        <g stroke="#60a5fa" strokeWidth="1.2" opacity="0.35">
          <line x1="260" y1="280" x2="720" y2="470" />
          <line x1="360" y1="220" x2="820" y2="180" />

          {/* New connected line */}
          <line
            x1="720"
            y1="470"
            x2="870"
            y2="330"
          />
        </g>

        {/* Nodes */}
        <g fill="#60a5fa" opacity="0.78">
          <circle cx="160" cy="220" r="4" />
          <circle cx="260" cy="280" r="4" />
          <circle cx="360" cy="220" r="4" />

          <circle cx="820" cy="180" r="4" />
          <circle cx="970" cy="270" r="4" />

          <circle cx="720" cy="470" r="5" />

          {/* Connector node */}
          <circle cx="870" cy="330" r="5" />

          <circle cx="920" cy="530" r="4" />
        </g>
      </svg>

      <form
        onSubmit={handleLogin}

        className="
          relative
          z-10
          bg-white/95
          backdrop-blur-xl
          p-10
          rounded-3xl
          shadow-[0_20px_60px_rgba(0,0,0,0.35)]
          border
          border-white/10
          w-full
          max-w-sm
        "
      >
        <div className="flex justify-center">
          <img
            src={logo}
            alt="RIGO"
            className="h-14 object-contain"
          />
        </div>
        <p className="text-sm text-slate-500 mb-2 text-center">
          R I G O
        </p>

        <p className="text-xs text-slate-500 mt-2 text-center">
          Digital Risk Intelligence & Governance Platform
        </p>

        {error && <div className="text-red-600 text-sm mb-4">{error}</div>}

        <div className="mb-4 mt-6">
          <label className="block text-sm font-medium text-gray-700">
            Username
          </label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="
              mt-2
              w-full
              rounded-xl
              border
              border-slate-200
              bg-white/80
              px-4
              py-3
              focus:ring-2
              focus:ring-cyan-200
              outline-none
              transition
              "
            required
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="
              mt-2
              w-full
              rounded-xl
              border
              border-slate-200
              bg-white/80
              px-4
              py-3
              focus:ring-2
              focus:ring-cyan-200
              outline-none
              transition
              "
            required
          />
        </div>

        <button
          type="submit"
          className="
            w-full
            rounded-xl
            bg-gradient-to-r
            from-cyan-600
            to-blue-700
            hover:from-cyan-500
            hover:to-blue-600
            text-white
            font-semibold
            py-3
            transition
            shadow-lg
            "
        >
          Login
        </button>

      </form>

    </div>
  );
};

export default Login;
